export default "__VITE_ASSET__Bjp5DpXd__"